import { Component } from '@angular/core';
import { NavController,AlertController,App } from 'ionic-angular';

import { StorageService } from '../../../providers/service/storageservice';
import { LoginPage } from '../../login/login/login';
import { AppState } from '../../../app/app.global';
import { WebService } from '../../../providers/service/webservice';

/**
 * Generated class for the BookborrowPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@Component({
  selector: 'page-bookborrow',
  templateUrl: 'bookborrow.html',
})
export class BookborrowPage {
	bookBoorowList:any;
  user:any =null;
	constructor (private alertCtrl: AlertController,public appCtrl: App,public global: AppState,private webService:WebService) {
		this.user = StorageService.getObj('currentUser');
		//修改密码时判断是否登录，未登录跳转到登录地址
		if(this.user==null||this.user==""||this.user.userId==null||this.user.userId=='undefined'||this.user.userId==''){
      		StorageService.remove('currentUser');
      		this.appCtrl.getRootNav().push(LoginPage);
    	}
	
			this.bookBoorowList=[
				{name:'经济学思维方式',boorowDate:'2018-05-03',isExpired:'否'},
				{name:'高等数学',boorowDate:'2018-02-01',isExpired:'否'},
				{name:'Java基础教程',boorowDate:'2017-07-03',isExpired:'是'},
				{name:'c++',boorowDate:'2018-03-01',isExpired:'否'},
				{name:'数据原理',boorowDate:'2018-05-01',isExpired:'否'},
			]
	}

}



// WEBPACK FOOTER //
// ./src/pages/about/bookborrow/bookborrow.ts